import React from 'react'
import { useTranslation } from 'react-i18next'

import { Text, ConfirmationResultModal } from '@percent/lemonade'
import { useMutation } from '@percent/utility'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import type { SetTwoFaMandatoryModalProps } from './SetTwoFaMandatoryModal.types'

export function SetTwoFaMandatoryModal({ isOpen, onClose, onSuccess, account }: SetTwoFaMandatoryModalProps) {
  const { t } = useTranslation()
  const { authenticationService } = useServices()

  const name = account.fullName ?? account.email

  const [{ status, isPending, errorMessage }, { mutateAsync: setTwoFaMandatory }] = useMutation(
    authenticationService.set2FAMandatory
  )

  const state = status === 'success' ? 'success' : status === 'error' ? 'failure' : undefined

  const enableTwoFa = !account.twoFaMandatory

  const handleConfirm = async () => {
    try {
      await setTwoFaMandatory({ accountId: account.id, twoFaMandatory: enableTwoFa })
      onSuccess?.()
    } catch (err) {
      // no-op
    }
  }

  const translationKey = `account.modify.set2FAMandatory.${enableTwoFa ? 'enable' : 'disable'}` as const

  return (
    <ConfirmationResultModal
      success={{
        title: t(`${translationKey}.success`),
        button: t('button.close')
      }}
      failure={{
        title: t(`${translationKey}.failure`),
        description: errorMessage,
        button: t('button.close')
      }}
      title={t(`${translationKey}.title`)}
      primaryButtonText={t(`${translationKey}.confirmButton`)}
      secondaryButtonText={t('button.cancel')}
      primaryBtnTestId="set-twofa-mandatory-submit-button"
      secondaryBtnTestId="set-twofa-mandatory-cancel-button"
      buttonTestId="set-twofa-mandatory-close-button"
      state={state}
      loading={isPending}
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleConfirm}
    >
      <Text>{t(`${translationKey}.description`, { name })}</Text>
    </ConfirmationResultModal>
  )
}
